export const useStatusHandler = (controller) => {
    Object.assign(controller, {
        statusValueChanged() {
            this.updateStatusTargets()
        },

        updateStatusTargets() {
            const disableClass = "has-text-grey"
            const enableClass = "is-active"

            for (let statusTarget of this.statusTargets) {
                if (statusTarget.value === this.statusValue) {
                    statusTarget.classList.remove(disableClass)
                    statusTarget.classList.add(enableClass)
                } else if (statusTarget.classList.contains(enableClass)) {
                    statusTarget.classList.remove(enableClass)
                    statusTarget.classList.add(disableClass)
                }
            }
        }
    })

    controller.updateStatusTargets()
}